// ----------------------------------------------------------------------------
// Component: Accordion
// ----------------------------------------------------------------------------
//
// Generic accordion component.
//
// Requires the following structure:
// .js-accordion__item
//     .js-accordion__button
//     .js-accordion__content
//
// When the button is clicked, 'isOpen' class is added/removed for all three
// elements.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './accordion.scss';


// -------------------------------------
// Variables
// -------------------------------------

var ACCORDION              = '.js-accordion';
var ACCORDION_OPEN_DEFAULT = '.js-accordion__open';
var ACCORDION_BUTTON       = '.js-accordion__button';
var ACCORDION_ITEM         = '.js-accordion__item';
var ACCORDION_CONTENT      = '.js-accordion__content';
var ACCORDION_TITLE        = '.accordion__title';

// Constant trigger classes
var OPEN_CLASS          = 'is-open';




// -------------------------------------
// Helper Functions
// -------------------------------------

function handleAccordion(accordion) {
    accordion.$item.parent().find('.' + OPEN_CLASS).removeClass(OPEN_CLASS);

    accordion.$item.parent().find(ACCORDION_CONTENT).css('overflow', 'hidden').attr('hidden', true);

    accordion.$item.parent().find(ACCORDION_BUTTON).attr('aria-expanded', 'false');
    
    if($(window).width() < 1025) {
        accordion.$item.parent().find(ACCORDION_CONTENT + " a").attr('tabindex', -1);
    } else {
        accordion.$item.parent().find(ACCORDION_CONTENT + " a").attr('tabindex', 0);
    }

    if (accordion.isOpening) {
        accordion.$button
            .add(accordion.$item)
            .add(accordion.$content)
            .addClass(OPEN_CLASS);

        accordion.$button.attr('aria-expanded', 'true');
        accordion.$content.attr('hidden', false);
        accordion.$content.find('a').attr('tabindex', null);

        // This allows select boxes to flow out after it's opened
        setTimeout(function() {
            accordion.$content.css('overflow', 'visible');
        }, 200);
    }
}


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() { 
    
    $(window).on('resize', function(e) {
        if($(window).width() < 1025 && !$(ACCORDION_ITEM).hasClass("is-open")) {
            $(ACCORDION_CONTENT + " a").attr('tabindex', -1);
        } else {
            $(ACCORDION_CONTENT + " a").attr('tabindex', 0);
        }
    });
    
    // Open first accordion on page load
    if( $(ACCORDION_OPEN_DEFAULT).length ) {
        $(ACCORDION_OPEN_DEFAULT).each(function(index) {
            $(this).find(ACCORDION_BUTTON).attr("aria-expanded", "false");
            $(this).find(ACCORDION_ITEM).first().addClass(OPEN_CLASS);
            $(this).find(ACCORDION_BUTTON).first().addClass(OPEN_CLASS);
            $(this).find(ACCORDION_BUTTON).first().attr("aria-expanded", "true");
            $(this).find(ACCORDION_CONTENT).first().attr('hidden', false);
            $(this).find(ACCORDION_CONTENT).first().addClass(OPEN_CLASS);
        });
    }

    $(ACCORDION_BUTTON).on('click keydown', function(e) {
        /**
         * click: Check state of the accordion item then pass on an action
         *
         * @param {Event} e
         * @return void
         */


        //e.preventDefault();

        // Store elements as an object
        var accordion = {
            $button:    $(e.target),
            $item:      $(e.target).parents(ACCORDION_ITEM),
            $title:     $(e.target).parents(ACCORDION_TITLE),
            $content:   $(e.target).parents(ACCORDION_TITLE).siblings(ACCORDION_CONTENT),
            isOpening:  !$(e.target).hasClass(OPEN_CLASS),
            $container: $(e.target).closest(ACCORDION),
            $button_group: $(e.target).closest(ACCORDION).find(ACCORDION_BUTTON)
        };
        // Collapse any open sibling & children accordions if data attribute set to true
        if (e.type === 'click') {
            e.preventDefault();
            handleAccordion(accordion);
        }
        else if (e.type === 'keydown') {
            let key = e.which.toString();
            if (key.match(/35|36|38|40/)) {
                e.preventDefault();
                let index = $.inArray(e.target, accordion.$button_group);
                let length = accordion.$button_group.length;
                let newIndex;
                switch(key) {
                    case '38': // Up
                        newIndex = (index + length + -1) % length;
                        accordion.$button_group[newIndex].focus();
                        break;
                    case '40': // Down
                        newIndex = (index + length + 1) % length;
                        accordion.$button_group[newIndex].focus();
                        break;
                    case '35': // End
                        accordion.$button_group[length - 1].focus();
                        break;
                    case '36': // Home
                        accordion.$button_group[0].focus();
                        break;
                }
            }
        }
    });
});
